import { render } from "./AppLink.vue?vue&type=template&id=26575de0&scoped=true"
import script from "./AppLink.vue?vue&type=script&lang=js"
export * from "./AppLink.vue?vue&type=script&lang=js"

import "./AppLink.vue?vue&type=style&index=0&id=26575de0&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26575de0"]])

export default __exports__